function getParticle(name) {
  if (!name) return '는';
  const code = name.charCodeAt(name.length - 1);
  if (code >= 0xAC00 && code <= 0xD7A3) {
    return (code - 0xAC00) % 28 > 0 ? '은' : '는';
  }
  return '는';
}

function PrivacyContent({ companyName = "수집주체명", trustee = "퍼널스(Funnels)" }) {
  return (
    <>
      <p><span>■ 개인정보처리방침</span></p>
      <p>
        [{companyName}]{getParticle(companyName)} 고객님의 개인정보를 중요시하며, 「개인정보 보호법」 및 관련 법령을 준수하고 있습니다. 본 방침을 통해 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있는지 알려드립니다.
      </p>
      <p>
        <span>1. 수집하는 개인정보 항목 및 방법</span>
        수집항목: 이름, 휴대전화번호, 상담 희망 내용, 서비스 이용 기록, 접속 로그<br />
        수집방법: 홈페이지 및 랜딩페이지 상담신청 양식
      </p>
      <p>
        <span>2. 개인정보의 수집 및 이용목적</span>
        이용목적: 상담 신청에 따른 본인 확인, 예약 안내를 위한 안내 연락(해피콜 및 문자/알림톡 발송), 맞춤형 의료 서비스 안내
      </p>
      <p>
        <span>3. 개인정보의 보유 및 이용기간</span>
        보유 및 이용기간: 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br />
        법령에 의한 보존: 단, 관계 법령(전자상거래 등에서의 소비자보호에 관한 법률 등)의 규정에 의하여 보전할 필요가 있는 경우 최대 3년간 보관합니다.
      </p>
      <p>
        <span>4. 개인정보의 파기절차 및 방법</span>
        파기절차: 목적이 달성된 후 별도의 DB로 옮겨져 일정 기간 저장된 후 파기됩니다.<br />
        파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
      </p>
      <p>
        <span>5. 개인정보 처리 위탁</span>
        병원은 원활한 서비스 제공 및 시스템 관리를 위해 아래와 같이 전문업체에 업무를 위탁하고 있으며, 수탁업체가 개인정보 보호법을 준수하도록 관리·감독하고 있습니다.<br />
        수탁업체: {trustee}<br />
        위탁업무: 랜딩페이지 및 DB 관리 시스템 운영, 마케팅 유입 분석 및 기술 지원
      </p>
      <p>
        <span>6. 개인정보 보호책임자 및 문의처</span>
        고객의 개인정보를 보호하고 관련 불만을 처리하기 위하여 아래와 같이 관련 부서 및 책임자를 지정하고 있습니다.<br />
        개인정보 보호책임자: 개인정보 관리 담당자<br />
        전화번호: 070-4495-2633<br />
        이메일: official@funnels.co.kr<br />
        주소: 서울 금천구 가산디지털1로 145, 에이스하이엔드타워3차
      </p>
    </>
  );
}

export default PrivacyContent;
